<svelte:head>
  <title>Contact details | A Good Thing</title>
</svelte:head>

{#if showToast}

<div class="notification is-success">
  <button class="delete" on:click={() => showToast = false}></button>
  Details saved.
</div>

{/if}

{#if data}

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label for="firstName" class="label">First name</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input id="firstName" class="input" type="text" placeholder="" bind:value={data.firstName} />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label for="lastName" class="label">Last name</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input id="lastName" class="input" type="text" placeholder="" bind:value={data.lastName} />
        </div>
      </div>
    </div>
  </div>

{#if $appState.user?.isAdmin && userEmail}
  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label for="email" class="label">Email</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input
            id="email"
            class="input"
            type="text"
            placeholder=""
            bind:value={userEmail}
            disabled
          />
        </div>
      </div>
    </div>
  </div>
{:else if data}
  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label for="email" class="label">Email</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input
            id="email"
            class="input"
            type="text"
            placeholder=""
            bind:value={$appState.auth_user.email}
            disabled
          />
        </div>
      </div>
    </div>
  </div>
{/if}

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label for="phone" class="label">Phone</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input id="phone" class="input" type="text" placeholder="" bind:value={data.phone} />
        </div>
      </div>
    </div>
  </div>

{/if}

<div class="field is-horizontal">
  <div class="field-label">
    <!-- Left empty for spacing -->
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <button class="button is-primary" class:is-loading={isLoading} on:click={save}> Save </button>
      </div>
    </div>
  </div>
</div>


<script lang="ts">
  import _ from "lodash";
  import { appState } from "../../../lib/appState";

  let showToast = false;
  let isLoading = false;
  let userEmail: string;
  let data: User_v1;

  let firebase = window.firebase;

  getContact();

  async function getContact() {

    if ($appState.user?.isAdmin) {

      firebase
      .firestore()
      .collection('users_v1')
      .where('charity', '==', $appState.user?.charity)
      .get()
      .then((snap) => {
        const doc = _.find(snap.docs, (doc) => !doc.data().isAdmin);
        if (doc) {
          userEmail = doc.id;
          data = doc.data() as User_v1;
        }
      })

    } else {

      if ($appState.user) {
        data = _.cloneDeep($appState.user)
        userEmail = $appState.auth_user.email;
      }

    }
  }

  async function save() {
    isLoading = true;

    await firebase
      .firestore()
      .collection("users_v1")
      .doc(userEmail)
      .update(data);

    if (!$appState.user?.isAdmin) $appState.user = data;

    isLoading = false;

    showToast = true;
  }
</script>
